import { type FC, type ReactNode } from 'react'

interface UpsellBodyLayoutProps {
  image: ReactNode
  heading: ReactNode
  description: ReactNode
}

export const UpsellBodyLayout: FC<UpsellBodyLayoutProps> = ({ image, heading, description }) => {
  return (
    <>
      {image}
      <div className='d-flex flex-column gap-1'>
        <h5>{heading}</h5>
        <div className='paragraph-medium'>{description}</div>
      </div>
    </>
  )
}
